module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"open":"Open","closed":"Closed","user_grade":"用户等级","author_grade":"创建者等级"}}')
  delete Component.options._Ctor
}
